
export function init(app) {
  app.ports.logEvent.subscribe(args => {
    logEvent(...args);
  });
  app.ports.setCurrentScreen.subscribe(screenName => {
    setCurrentScreen(screenName);
  });
}

function setCurrentScreen(screenName) {
  if (typeof firebase !== 'undefined')
    firebase.analytics().setCurrentScreen(screenName);
}

function logEvent(event, params) {
  const record = { ts: Date.now(), params };
  if (typeof firebase !== 'undefined')
    firebase.analytics().logEvent(event, record);
}